import PricingPlanLayout from './pricing_plan_layout';
import { PricingPlanContextProvider } from './context/pricing_plan_context';

// this displays the layout for project page
const PricingPlanPage = () => {
  return (
    <PricingPlanContextProvider>
      <PricingPlanLayout />
    </PricingPlanContextProvider>
  );
};

export default PricingPlanPage;